export const buildPatientConsentHistoryUrl = (
  route: string,
  clinicId: number,
  patientId: number,
  patientScope = false
) => {
  const url = route
    .replace("{clinic_id}", clinicId.toString())
    .replace("{patient_id}", patientId.toString());
  return patientScope ? `${url}?patient_scope=true` : url;
};
